import React, { useEffect, useState } from "react";
import { Typography, Spin, Select, Pagination, Button, Input } from "antd";
import * as dropDownActions from "../../../../actionCreators/DropDown";
import * as userActions from "../../../../actionCreators/User";
import InputLabel from "../../../../Components/FloatingSelectLabel/FloatingSelectLabel";
import { SearchOutlined, FilterFilled } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "./style/user.css";
const { Option } = Select;
const { Title } = Typography;
const { Search } = Input;
function ActivityLogs({
  logs,
  users,
  etoZones,
  getUsers,
  districts,
  currentUser,
  getEtoZones,
  getDistricts,
  circlesInZone,
  circlesOrZones,
  getActivityLogs,
  getCirclesByZone,
  userByZoneOrCircle,
  getUserByZoneOrCircle,
  getCircleOrZoneOfDistrict,
}) {
  const history = useHistory();
  const [Inspector, setInspector] = useState(null);
  const [districtName, setDistrictName] = useState(null);
  const [circle, setCircle] = useState(null);
  const [zone, setZone] = useState(null);
  const [zoneSelectActive, setZoneSelectActive] = useState(false);
  const [circleSelectActive, setCircleSelectActive] = useState(false);
  const [inspectorSelectActive, setInspetorSelectActive] = useState(false);
  const [showData, setShowData] = useState(false);
  const [user, setUser] = useState(null);
  const [userLoading, setUserLoading] = useState(false);
  const [activityLogs, setActivityLogs] = useState(null);
  const [loading, setLoading] = React.useState(false);
  const [pagination, setPagination] = React.useState({});
  const [pageSize, setPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [userType, setUserType] = useState(null);
  const [UserTypeSelectActive, setUserTypeSelectActive] = useState(false);
  const [district, setDistrict] = useState(null);
  const [districtSelectActive, setDistrictSelectActive] = useState(false);
  const [isDistrictAdmin, setIsDistrictAdmin] = useState(false);
  useEffect(() => {
    if (currentUser.data) {
      if (currentUser?.data?.user_roles.findIndex((e) => e.role_id == 3) >= 0) {
        setIsAdmin(true);
      } else if (currentUser?.data?.user_roles.findIndex((e) => e.role_id == 5) >= 0) {
        setIsDistrictAdmin(true);
      }
    }
  }, []);
  useEffect(() => {
    if (isAdmin  || isDistrictAdmin) {
      getDistricts();
    } else {
      getEtoZones();
    }
  }, [isAdmin, isDistrictAdmin]);
  useEffect(() => {
    if (zone) {
      if (isAdmin || isDistrictAdmin) {
        getUserByZoneOrCircle({ id: zone, user: "ETO" });
      } else {
        getCirclesByZone({ zone_id: zone });
      }
    }
  }, [zone]);
  useEffect(() => {
    if (district) {
      if (userType === "eto") {
        getCircleOrZoneOfDistrict({ type: "zone", district_id: district });
      } else {
        getCircleOrZoneOfDistrict({ type: "circle", district_id: district });
      }
    }
  }, [district]);
  useEffect(() => {
    setUser(users.data);
    setUserLoading(users.loading);
  }, [users]);
  useEffect(() => {
    if (circle) {
      getUserByZoneOrCircle({ id: circle, user: "TI" });
    }
  }, [circle]);
  useEffect(() => {
    if (logs.data) {
      setActivityLogs(logs.data);
      setLoading(logs.loading);
      setPagination(logs.pagination);
    }
  }, [logs]);
  useEffect(() => {
    if (districts.data) {
      for (let data of districts.data) {
        if (data?.id === district) {
          setDistrictName(data?.name);
        }
      }
    }
  }, [district]);
  let filterTemplate = [
    {
      text: "Crf Creation",
      value: "CRF_CREATED",
    },
    {
      text: "Detected Property Assignment",
      value: "NEW_DETECTED_PROPERTY_ASSIGNED",
    },
    {
      text: "Property Created",
      value: "PROPERTY_CREATED",
    },
    {
      text: "Property Updated",
      value: "PROPERTY_UPDATED",
    },
    {
      text: "PH10 Issued",
      value: "PH10_ISSUED",
    },
    {
      text: "Split Property",
      value: "PROPERTY_SPLIT",
    },
    {
      text: "Consolidate Property",
      value: "PROPERTY_MERGED",
    },
    {
      text: "Remove Property",
      value: "TI_REMOVED_DETECTED_PROPERTY",
    },
    {
      text: "PH9 Issued",
      value: "PH9_ISSUED",
    },
    {
      text: "Detection Process",
      value: "ML_ENGINE_RUN",
    },
    {
      text: "CRF Approval",
      value: "ETO_APPROVED_CRF",
    },
    {
      text: "CRF Rejected",
      value: "ETO_REJECTED_CRF",
    },
    {
      text: "PH1 Issued",
      value: "PH1_ISSUED",
    },
    {
      text: "Approvals",
      value: "PAYMENT_APPROVED",
    },
    {
      text: "Property Approvals",
      value: "PROPERTY_APPROVED",
    },
    {
      text: "Property Rejected",
      value: "PROPERTY_REJECTED",
    },
    {
      text: "Objections",
      value: "OBJECTED_FORWARDED",
    },
    {
      text: "Update Payments",
      value: "PAYMENT_UPDATED",
    },
  ];
  const handleLogsSearch = async () => {
    setUserLoading(true);
    await getUsers({ user_id: Inspector });
    if (userType) {
      if (userType === "eto") {
        await getActivityLogs({
          circle_id: circle,
          eto_id: Inspector,
          page: 0,
          pageSize: pageSize,
        });
      } else if (userType === "ti") {
        await getActivityLogs({
          circle_id: circle,
          inspector_id: Inspector,
          page: 0,
          pageSize: pageSize,
        });
      }
    } else {
      await getActivityLogs({
        circle_id: circle,
        inspector_id: Inspector,
        page: 0,
        pageSize: pageSize,
      });
    }
    setShowData(true);
  };
  const handleTableChange = async (page, pageSize) => {
    setLoading(true);
    setPageSize(pageSize);
    if (userType === "eto") {
      getActivityLogs({
        circle_id: circle,
        eto_id: Inspector,
        page: page - 1,
        pageSize: pageSize,
        pin: searchValue,
      });
    } else if (userType === "ti") {
      await getActivityLogs({
        circle_id: circle,
        inspector_id: Inspector,
        page: page - 1,
        pageSize: pageSize,
        pin: searchValue,
      });
    } else {
      await getActivityLogs({
        circle_id: circle,
        inspector_id: Inspector,
        page: page - 1,
        pageSize: pageSize,
        pin: searchValue,
      });
    }
  };
  const handleSearch = async (event) => {
    setLoading(true);
    setSearchValue(event);
    if (userType === "eto") {
      getActivityLogs({
        circle_id: circle,
        eto_id: Inspector,
        page: 0,
        pageSize: pageSize,
        pin: event,
      });
    } else if (userType === "ti") {
      await getActivityLogs({
        circle_id: circle,
        inspector_id: Inspector,
        page: 0,
        pageSize: pageSize,
        pin: event,
      });
    } else {
      await getActivityLogs({
        circle_id: circle,
        inspector_id: Inspector,
        page: 0,
        pageSize: pageSize,
        pin: event,
      });
    }
  };
  const template = (data) => {
    const eto = data?.eto?.full_name.toUpperCase();
    const inspector = data?.taxInspector?.full_name.toUpperCase();
    const property = data?.property?.pin;
    const detectedProperty = data?.detectedPropertyId;
    const action = data?.action;
    const date = new Date(data.createdAt).toLocaleString();
    switch (action) {
      case "PAYMENT_REJECTED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} rejected payment of property{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
      case "CRF_CREATED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} added CRF for property{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "NEW_DETECTED_PROPERTY_ASSIGNED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              New Detected Property against UID{" "}
              <Link
                to={"/detected/all"}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {detectedProperty}
              </Link>{" "}
              assigned to {inspector} by {eto}.
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PROPERTY_CREATED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} added a property with 
              {
                property?
                <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : ` Property No. ${data?.propertyId}`}
              </Link>:
              <span> Property No. {data?.propertyId}</span>
              }
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PROPERTY_UPDATED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} updated property against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.propertyId}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PH10_ISSUED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} generated PH10 form against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PROPERTY_SPLIT":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} splited detected property against UID{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {detectedProperty}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PROPERTY_MERGED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} consolidated detected property against UID{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {detectedProperty}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "TI_REMOVED_DETECTED_PROPERTY":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} removed detected property against UID{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {detectedProperty}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PH9_ISSUED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} generated PH10 Challan against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "ML_ENGINE_RUN":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} ran Property Detection Model (ML Engine).
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "ETO_APPROVED_CRF":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} approved CRF against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "ETO_REJECTED_CRF":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} rejected CRF against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PH1_ISSUED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} issued PH1 Form against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.propertyId}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PAYMENT_APPROVED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} approved tax payment against{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PROPERTY_APPROVED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} approved property{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PROPERTY_REJECTED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} rejected property{" "}
              {
                property?
                <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.propertyId}`}
              </Link>:
              <span>Property No. {data?.propertyId}</span>
              }
              .
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "OBJECTED_FORWARDED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {eto} forwarded objection from the owner of property{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>{" "}
              to Tax Inspector.
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      case "PAYMENT_UPDATED":
        return (
          <div className="activity-container">
            <div className="activity-header">
              {inspector} updated the payment details against property{" "}
              <Link
                to={"/properties/view/" + data?.propertyId}
                target="_blank"
                style={{
                  color: "rgb(44, 175, 219)",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {property
                  ? `${property}`
                  : `Property No. ${data?.property?.pin}`}
              </Link>{" "}
              to Tax Inspector.
            </div>
            <div className="activity-time">{date}</div>
          </div>
        );
        break;
      default:
        return (
          <div className="activity-container">
            <div className="activity-header">
              {action} 
            </div>
            <div className="activity-time">{date}</div>
          </div>
          );
    }
  };
  const handleFilterSearch = async (event) => {
    if (event) {
      if (userType === "eto") {
        getActivityLogs({
          circle_id: circle,
          eto_id: Inspector,
          page: 0,
          pageSize: pageSize,
          filter: event,
        });
      } else if (userType === "ti") {
        await getActivityLogs({
          circle_id: circle,
          inspector_id: Inspector,
          page: 0,
          pageSize: pageSize,
          filter: event,
        });
      }
    }
  };
  return (
    <div>
      <div className="header">
        <Typography className="heading">Activity Log</Typography>
      </div>
      <div className="logs-body">
        <div className="logs-header">
          {(isAdmin || isDistrictAdmin) ? (
            <Title level={4}>Select an ETO or TI to view their Activity</Title>
          ) : (
            <Title level={4}>Select TI to view their Activity</Title>
          )}
        </div>
        <div className="dropdown-container">
          {(isAdmin || isDistrictAdmin) ? (
            <>
              <div
                onFocus={() => {
                  setUserTypeSelectActive(true);
                }}
                onBlur={() => {
                  setUserTypeSelectActive(false);
                }}
                className="dropdowns"
              >
                <InputLabel
                  value={userType}
                  labelText="User"
                  active={UserTypeSelectActive}
                >
                  <Select
                    size="large"
                    onChange={(event) => {
                      setUserType(event);
                      setDistrict(null);
                      setZone(null);
                      setZoneSelectActive(false);
                      setCircle(null);
                      setCircleSelectActive(false);
                      setInspector(null);
                      setInspetorSelectActive(false);
                      setDistrictSelectActive(false);
                      setShowData(false);
                    }}
                    value={userType}
                    allowClear
                  >
                    <Option value="eto">ETO</Option>
                    <Option value="ti">Tax Inspector</Option>
                  </Select>
                </InputLabel>
              </div>
              <div
                onFocus={() => {
                  setDistrictSelectActive(true);
                }}
                onBlur={() => {
                  setDistrictSelectActive(false);
                }}
                className="dropdowns"
              >
                <InputLabel
                  value={district}
                  labelText="District"
                  active={districtSelectActive}
                >
                  <Select
                    size="large"
                    onChange={(event) => {
                      setDistrict(event);
                      setZone(null);
                      setZoneSelectActive(false);
                      setCircle(null);
                      setCircleSelectActive(false);
                      setInspector(null);
                      setInspetorSelectActive(false);
                      setShowData(false);
                    }}
                    value={district}
                    disabled={userType ? false : true}
                    loading={
                      userType ? (districts?.data ? false : true) : false
                    }
                    allowClear
                  >
                    {districts?.data &&
                      districts?.data.map((value) => {
                        return (
                          <Option value={value.id} key={value.id}>
                            {value.name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputLabel>
              </div>
              {userType === "eto" ? (
                <div
                  onFocus={() => {
                    setZoneSelectActive(true);
                  }}
                  onBlur={() => {
                    setZoneSelectActive(false);
                  }}
                  className="dropdowns"
                >
                  <InputLabel
                    value={zone}
                    labelText="Zone"
                    active={zoneSelectActive}
                  >
                    <Select
                      size="large"
                      disabled={district ? false : true}
                      onChange={(event) => {
                        // if (event) {
                        setZone(event);
                        setInspector(null);
                        setInspetorSelectActive(false);
                        setShowData(false);
                        // }
                      }}
                      value={zone}
                      loading={
                        district ? (circlesOrZones?.data ? false : true) : false
                      }
                      allowClear
                    >
                      {circlesOrZones?.data &&
                        circlesOrZones?.data.map((zones) => {
                          return (
                            <Option value={zones.id} key={zones.id}>
                              {zones.name}
                            </Option>
                          );
                        })}
                    </Select>
                  </InputLabel>
                </div>
              ) : userType === "ti" ? (
                <div
                  onFocus={() => {
                    setCircleSelectActive(true);
                  }}
                  onBlur={() => {
                    setCircleSelectActive(false);
                  }}
                  className="dropdowns"
                >
                  <InputLabel
                    value={circle}
                    labelText="Circle"
                    active={circleSelectActive}
                  >
                    <Select
                      size="large"
                      disabled={district ? false : true}
                      value={circle}
                      onChange={(event) => {
                        setCircle(event);
                        setInspector(null);
                        setInspetorSelectActive(false);
                        setShowData(false);
                      }}
                      loading={
                        district ? (circlesOrZones?.data ? false : true) : false
                      }
                      allowClear
                    >
                      {circlesOrZones?.data &&
                        circlesOrZones.data.map((circles) => {
                          return (
                            <Option value={circles.id} key={circles.id}>
                              {circles.name}
                            </Option>
                          );
                        })}
                    </Select>
                  </InputLabel>
                </div>
              ) : (
                <div
                  onFocus={() => {
                    setCircleSelectActive(true);
                  }}
                  onBlur={() => {
                    setCircleSelectActive(false);
                  }}
                  className="dropdowns"
                >
                  <InputLabel
                    value={circle}
                    labelText="Zone/Circle"
                    active={circleSelectActive}
                  >
                    <Select
                      size="large"
                      disabled={district ? false : true}
                      value={circle}
                      onChange={(event) => {
                        setCircle(event);
                        setInspector(null);
                        setInspetorSelectActive(false);
                        setShowData(false);
                      }}
                      loading={
                        zone ? (circlesInZone?.data ? false : true) : false
                      }
                      allowClear
                    >
                      {circlesInZone.data &&
                        circlesInZone.data.map((circlesInZone) => {
                          return (
                            <Option
                              value={circlesInZone.id}
                              key={circlesInZone.id}
                            >
                              {circlesInZone.name}
                            </Option>
                          );
                        })}
                    </Select>
                  </InputLabel>
                </div>
              )}
              <div
                onFocus={() => {
                  setInspetorSelectActive(true);
                }}
                onBlur={() => {
                  setInspetorSelectActive(false);
                }}
                className="dropdowns"
              >
                <InputLabel
                  value={Inspector}
                  labelText={
                    userType === "eto"
                      ? "ETO Name"
                      : userType === "ti"
                      ? "Tax Inspector Name"
                      : "Username"
                  }
                  active={inspectorSelectActive}
                >
                  <Select
                    size="large"
                    disabled={circle || zone ? false : true}
                    onChange={(event) => {
                      setInspector(event);
                      setShowData(false);
                    }}
                    value={Inspector}
                    allowClear
                    loading={
                      circle ? (userByZoneOrCircle.data ? false : true) : false
                    }
                  >
                    {userByZoneOrCircle.data &&
                      userByZoneOrCircle.data.map((value) => {
                        return (
                          <Option value={value.id} key={value.id}>
                            {value?.full_name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputLabel>
              </div>
            </>
          ) : (
            <>
              <div
                onFocus={() => {
                  setZoneSelectActive(true);
                }}
                onBlur={() => {
                  setZoneSelectActive(false);
                }}
                className="dropdowns"
              >
                <InputLabel
                  value={zone}
                  labelText="Zone"
                  active={zoneSelectActive}
                >
                  <Select
                    size="large"
                    disabled={etoZones ? false : true}
                    onChange={(event) => {
                      // if (event) {
                      setZone(event);
                      setCircle(null);
                      setInspector(null);
                      setCircleSelectActive(false);
                      setInspetorSelectActive(false);
                      setShowData(false);
                      // }
                    }}
                    value={zone}
                    loading={etoZones.data ? false : true}
                    allowClear
                  >
                    {etoZones.data &&
                      etoZones.data.map((etoZones) => {
                        return (
                          <Option value={etoZones.id} key={etoZones.id}>
                            {etoZones.zone}
                          </Option>
                        );
                      })}
                  </Select>
                </InputLabel>
              </div>
              <div
                onFocus={() => {
                  setCircleSelectActive(true);
                }}
                onBlur={() => {
                  setCircleSelectActive(false);
                }}
                className="dropdowns"
              >
                <InputLabel
                  value={circle}
                  labelText="Circle"
                  active={circleSelectActive}
                >
                  <Select
                    size="large"
                    disabled={zone ? false : true}
                    value={circle}
                    onChange={(event) => {
                      setCircle(event);
                      setInspector(null);
                      setInspetorSelectActive(false);
                      setShowData(false);
                    }}
                    loading={
                      zone ? (circlesInZone?.data ? false : true) : false
                    }
                    allowClear
                  >
                    {circlesInZone.data &&
                      circlesInZone.data.map((circlesInZone) => {
                        return (
                          <Option
                            value={circlesInZone.id}
                            key={circlesInZone.id}
                          >
                            {circlesInZone.name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputLabel>
              </div>
              <div
                onFocus={() => {
                  setInspetorSelectActive(true);
                }}
                onBlur={() => {
                  setInspetorSelectActive(false);
                }}
                className="dropdowns"
              >
                <InputLabel
                  value={Inspector}
                  labelText="Tax Inspector"
                  active={inspectorSelectActive}
                >
                  <Select
                    size="large"
                    disabled={circle ? false : true}
                    onChange={(event) => {
                      setInspector(event);
                      setShowData(false);
                    }}
                    value={Inspector}
                    allowClear
                    loading={
                      circle ? (userByZoneOrCircle.data ? false : true) : false
                    }
                  >
                    {userByZoneOrCircle.data &&
                      userByZoneOrCircle.data.map((value) => {
                        return (
                          <Option value={value.id} key={value.id}>
                            {value?.full_name}
                          </Option>
                        );
                      })}
                  </Select>
                </InputLabel>
              </div>
            </>
          )}
        </div>
        <div className="search-button-container">
          <Button
            className={
              (isAdmin || isDistrictAdmin)
                ? userType && district && (circle || zone) && Inspector
                  ? "search-button"
                  : "search-button-disabled"
                : zone && circle && Inspector
                ? "search-button"
                : "search-button-disabled"
            }
            icon={<SearchOutlined />}
            onClick={handleLogsSearch}
            disabled={
              (isAdmin || isDistrictAdmin)
                ? userType && district && (circle || zone) && Inspector
                  ? false
                  : true
                : zone && circle && Inspector
                ? false
                : true
            }
          >
            Search
          </Button>
        </div>
      </div>
      {userLoading ? (
        <div
          style={{
            width: "98.3%",
            height: "30vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "white",
            margin: "20px 10px",
          }}
        >
          <Spin />
        </div>
      ) : (
        <div className="data-container">
          {showData && user && (
            <>
              <div className="logs-container">
                <div className="logs-header">
                  <div className="search-input">
                    <Title level={4}>Activity Logs</Title>
                  </div>
                  {(isAdmin || isDistrictAdmin) ? (
                    <div className="search-and-filter">
                      <Search
                        className="search-input"
                        placeholder="Search by Property No. or PIN"
                        enterButton
                        onSearch={handleSearch}
                        allowClear
                      />
                      <Select
                        className="filter-dropdown"
                        mode="multiple"
                        placeholder="Search Filters"
                        alowClear
                        onChange={handleFilterSearch}
                      >
                        {filterTemplate.map((data, index) => (
                          <Option value={data.value} key={index}>
                            {data.text}
                          </Option>
                        ))}
                      </Select>
                    </div>
                  ) : (
                    <Search
                      className="search-input"
                      placeholder="Search by Property No. or PIN"
                      enterButton
                      onSearch={handleSearch}
                      allowClear
                    />
                  )}
                  {/* <FilterFilled /> */}
                </div>
                {loading ? (
                  <div
                    style={{
                      width: "100%",
                      height: "30vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Spin />
                  </div>
                ) : activityLogs?.length === 0 ? (
                  <div
                    style={{
                      width: "100%",
                      height: "30vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      opacity: 0.5,
                    }}
                  >
                    No Logs Found.
                  </div>
                ) : (
                  <div>
                    {activityLogs &&
                      activityLogs.map((data) => {
                        let div = template(data);
                        return div;
                      })}
                    <div className="pagination">
                      <Pagination
                        current={pagination.currentPage + 1}
                        total={pagination.count}
                        defaultPageSize={10}
                        pageSize={pageSize}
                        pageSizeOptions={["10", "20", "30"]}
                        onChange={handleTableChange}
                        showSizeChanger={true}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="user-info-container">
                <div className="logs-header">
                  {(isAdmin || isDistrictAdmin) ? (
                    <>
                      {userType === "eto" ? (
                        <Title level={4}>ETO Details</Title>
                      ) : (
                        <Title level={4}>TI Details</Title>
                      )}
                    </>
                  ) : (
                    <Title level={4}>TI Details</Title>
                  )}
                </div>
                <div className="details-data-container">
                  {user?.full_name ? (
                    <div className="details-container">
                      <div className="details-header">Name</div>
                      <div className="details-data">{user.full_name}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {user?.email ? (
                    <div className="details-container">
                      <div className="details-header">Email</div>
                      <div className="details-data">{user.email}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {user?.phone ? (
                    <div className="details-container">
                      <div className="details-header">Phone</div>
                      <div className="details-data">{user?.phone}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {user?.address ? (
                    <div className="details-container">
                      <div className="details-header">Home Address</div>
                      <div className="details-data">{user.address}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {district ? (
                    <div className="details-container">
                      <div className="details-header">District</div>
                      <div className="details-data">{districtName}</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {zone
                    ? circlesOrZones?.data?.map((zones, index) => {
                        if (zones.id === zone) {
                          return (
                            <div className="details-container" key={index}>
                              <div className="details-header">Zone</div>
                              <div className="details-data">{zones.name}</div>
                            </div>
                          );
                        }
                      })
                    : ""}
                  {user?.circles ? (
                    <div className="details-container">
                      <div className="details-header">Circles</div>
                      {user.circles.map((circle) => {
                        return (
                          <div className="details-data" key={circle.id}>
                            {circle.name}
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = ({
  dropDown: {
    districts,
    zones,
    users,
    etoZones,
    circlesInZone,
    circlesOrZones,
    userByZoneOrCircle,
  },
  user: { logs, currentUser },
}) => ({
  currentUser,
  districts,
  zones,
  users,
  logs,
  etoZones,
  circlesInZone,
  circlesOrZones,
  userByZoneOrCircle,
});

const mapDispatchToProps = (dispatch) => ({
  getEtoZones: bindActionCreators(dropDownActions.getEtoZones, dispatch),
  getUsers: bindActionCreators(dropDownActions.getUsers, dispatch),
  getUserByZoneOrCircle: bindActionCreators(
    dropDownActions.getUserByZoneOrCircle,
    dispatch
  ),
  getDistricts: bindActionCreators(dropDownActions.getDistricts, dispatch),

  getCirclesByZone: bindActionCreators(
    dropDownActions.getCirclesByZone,
    dispatch
  ),
  getCircleOrZoneOfDistrict: bindActionCreators(
    dropDownActions.getCircleOrZoneOfDistrict,
    dispatch
  ),
  getActivityLogs: bindActionCreators(userActions.getActivityLogs, dispatch),
});

ActivityLogs.propTypes = {
  getUsers: PropTypes.func.isRequired,
  getActivityLogs: PropTypes.func.isRequired,
  getEtoZones: PropTypes.func.isRequired,
  getCirclesByZone: PropTypes.func.isRequired,
  getUserByZoneOrCircle: PropTypes.func.isRequired,
  getDistricts: PropTypes.func.isRequired,
  getCircleOrZoneOfDistrict: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityLogs);
